import { FC, RefObject } from 'react';
import { Box, Flex, TabList } from '@chakra-ui/react';

import { OnboardingPlanDisplay } from '../../../../types';
import PlanTab from '../PlanTab';

interface PlanTabListProps {
  plans: OnboardingPlanDisplay[];
  markerRef: RefObject<HTMLDivElement>;
}

const PlanTabList: FC<PlanTabListProps> = ({ markerRef, plans }) => (
  <Flex
    _after={{
      background: 'grey.300',
      bottom: 0,
      content: '""',
      display: 'block',
      height: '1px',
      left: 0,
      position: 'absolute',
      width: '100%',
      zIndex: 1,
    }}
    background="white"
    paddingX="space-24"
    position="sticky"
    top={0}
    width="100%"
    zIndex={2}
  >
    <TabList
      display="grid"
      gridTemplateColumns={`repeat(${plans.length}, 1fr)`}
      justifyContent="center"
      position="relative"
      width="100%"
    >
      {plans.map(({ brandName }) => (
        <PlanTab key={brandName}>{brandName}</PlanTab>
      ))}
      <Box
        background="grey.800"
        borderRadius="radius-full"
        bottom={0}
        height="0.25rem"
        left={0}
        position="absolute"
        ref={markerRef}
        width={{ base: 1 / plans.length, md: '9rem' }}
        zIndex={2}
      />
    </TabList>
  </Flex>
);

export default PlanTabList;
